export default [
  // 添加班级
  {
    name: 'add-class-popup',
    component: () => import(/* webpackChunkName: "addClassPopup" */ './add-class-popup.vue'),
  },
  // 批量编辑
  {
    name: 'multiple-edit-class',
    component: () => import(/* webpackChunkName: "MultipleEditClass" */ './multiple-edit-class.vue'),
  },
  // 调整出入班时间
  {
    name: 'multiple-in-out-class',
    component: () => import(/* webpackChunkName: "MultipleInOutClass" */ './set-in-out-date.vue'),
  },
  // 移出班级
  {
    name: 'move-out-class',
    component: () => import(/* webpackChunkName: "MultipleOutClass" */ './move-out-class.vue'),
  },
  // 入班日期-班级
  {
    name: 'move-into-class',
    component: () => import(/* webpackChunkName: "MultipleIntoClass" */ './move-into-class.vue'),
  },
  // 调到其他班
  {
    name: 'move-other-class',
    component: () => import(/* webpackChunkName: "MultipleOtherClass" */ './move-other-class.vue'),
  },
  // 历史学员
  {
    name: 'class-history-student',
    component: () => import(/* webpackChunkName: "ClassHistoryStudent" */ './history-student.vue'),
  },
  // 失败结果
  {
    name: 'error-class-result',
    component: () => import(/* webpackChunkName: "ErrorClassResult" */ './error-class-result.vue'),
  },
];
